import { get } from "lodash";
import { Store } from "redux";

export const getEnablePopularRaces = (store: Store) =>
  get(store, "capi.featureToggles.showPopularRacesDesk", false);
